import { render, staticRenderFns } from "./logistics-edit.vue?vue&type=template&id=6669aa2c&"
import script from "./logistics-edit.vue?vue&type=script&lang=ts&"
export * from "./logistics-edit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports